import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_control_MousePosition from 'ol/control/MousePosition';

import { Util } from '../util';
import Map from '../map';
export class MousePosition extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            className: undefined,
            coordinateFormat: undefined,
            projection: undefined,
            render: undefined,
            target: undefined,
            undefinedHTML: undefined
        };
        this.events = {
            'change': undefined,
            'change:coordinateFormat': undefined,
            'change:projection': undefined,
            'propertychange': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        this.control = new ol_control_MousePosition(options);
        this.context.mapComp.controls.push(this.control);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.control.on(eventName, olEvents[eventName]);
        }
    }
}
MousePosition['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};